import Vue from 'vue';
import Router from 'vue-router';
// import About from '@/views/projects/About.vue';
import Index from '@/views/Index.vue';
import PShare from '@/views/PShare.vue';


Vue.use(Router);

export default new Router({
  mode: 'history',
  // base: '/hf2020/',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
    },
    // { path: '/about', name: 'pShare', component: About },
    {
      path: '/pShare',
      name: 'pShare',
      component: PShare,
    },
  ],
  scrollBehavior(to) {
    if (to.hash) {
      return { selector: to.hash };
    }

    return { x: 0, y: 0 };
  },
});
